import React from 'react'
import './App.css'
import Footer from './components/Footer'
import Header from './components/Header'
import Homepage from './components/Homepage'
import ProductsList from './components/ProductsList'
import SearchResults from './components/SearchResults'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import Checkout from './components/Checkout'
import About from './components/About'
import Contact from './components/Contact'
import CustomerService from './components/CustomerService'
import HowTo from './components/HowTo'
import Club from './components/Club'

function App() {
  return (
    <BrowserRouter>
      <div>
        <Header />
        <div className="App">
          <Routes>
            <Route exact path="/" element={<Homepage />} />
            <Route exact path="/about" element={<About />} />
            <Route exact path="/contact" element={<Contact />} />
            <Route exact path="/customer" element={<CustomerService />} />
            <Route exact path="/howto" element={<HowTo />} />
            <Route exact path="/club" element={<Club />} />
            <Route exact path="/search" element={<SearchResults />} />
            <Route path="/" element={<Homepage />} />

            <Route
              path="/hot-wheels"
              element={<ProductsList catName="Hot Wheels" catId={1} />}
            />
            <Route
              path="/lego-bilar"
              element={<ProductsList catName="LEGO Bilar" catId={2} />}
            />
            <Route
              path="/siku-bilar"
              element={<ProductsList catName="Siku Bilar" catId={3} />}
            />
            <Route
              path="/rc-bilar"
              element={<ProductsList catName="RC Bilar" catId={4} />}
            />

            <Route path="/varukorg" element={<Checkout />} />
          </Routes>
        </div>
        <Footer />
      </div>
    </BrowserRouter>
  )
}

export default App
